module.exports = __webpack_public_path__ + "static/bridgeeconomy-bffc3fe822b6fd5c7778c66fe8bbc1a2.png";